import script from "./Plants.vue?vue&type=script&setup=true&lang=js"
export * from "./Plants.vue?vue&type=script&setup=true&lang=js"

import "./Plants.vue?vue&type=style&index=0&id=7cd114ff&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd114ff"]])

export default __exports__